import FullPageLoader from '@/components/FullPageLoader';
import { useOrganizations } from '@/hooks/useOrganizations';
import { FunctionComponent } from 'react';

interface iOrganizationsLoaderProps {}

const OrganizationsLoaderPage: FunctionComponent<iOrganizationsLoaderProps> = () => {
  useOrganizations();
  return <FullPageLoader title='Loading Organizations' subtitle='Please wait while we load your organizations' />;
};

export default OrganizationsLoaderPage;
